"use client";

import type { CSSProperties } from "react";
import { useDvdScreensaver } from "react-dvd-screensaver";

import type { SiteVideoWatermark } from "@/templates/site/types";

const DRIFT_SPEED = 0.15;

export function VideoWatermark({ data }: { data: SiteVideoWatermark | null }) {

  const { elementRef } = useDvdScreensaver<HTMLSpanElement>({
    speed: DRIFT_SPEED,
  });

  if (!data) {
    return null;
  }

  return (
    <span
      ref={elementRef}
      className="video_shuiyin"
      style={{ "--shuiyin-nong": data.opacity / 100 } as CSSProperties}
      aria-hidden
    >
      {data.text}
    </span>
  );
}
